// extracted by mini-css-extract-plugin
export default {"wrapper":"hr-z","response":"ir-z","error":"jr-z","disabled":"kr-z","buttons":"lr-z","feedbackQuestionSection":"mr-z","yesNoWrapper":"nr-z"};